import BottomIconList from './bottomIconList'

export default BottomIconList